export default "__VITE_ASSET__DrvZy$nL__"